export default __webpack_public_path__ + "static/media/bb10.8f43ce74.png";